import * as types from '@/store/types'

export default {

    [types.GET_VENUES]: state => {
        return state.venues
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/temp_venue/getters.js